// extracted by mini-css-extract-plugin
export default {"container":"Y3-z","heading":"Z3-z","links":"_3-z","copy":"a4-z","subCopy":"b4-z","linksLeft":"c4-z","linksCenter":"d4-z","linksRight":"e4-z","link":"f4-z","onlyLink":"g4-z"};